(function ($) {
  /**
   * A quick jQuery plugin to make our sidebar menu behavior generic
   * Apply to a parent container
   */
  Drupal.behaviors.accordianMenu = {
    attach: function (context, settings) {
      $.fn.accordianMenu = function (options) {
        // Smoosh settings together with defaults
        var settings = $.extend({
          trigger: '.content-block-title',
          parent: 'aside',
          activeClass: 'is-active'
        }, options);

        // Clicking an expand-o menu
        this.on('click', settings.trigger, function (event) {
          var $parentItem = $(this).parent(settings.parent); // parent wrapper

          event.preventDefault();
          // Item is NOT active
          if (!$parentItem.hasClass(settings.activeClass)) {
            // Remove all active states
            $('.' + settings.activeClass, event.delegateTarget).removeClass(settings.activeClass);
          }
          // Toggle on active state
          $parentItem.toggleClass(settings.activeClass);
        }); // .on

        // for chaining
        return this;
      };
    }
  };

  /**
   * Customer service sidebar nav behavior
   */
  Drupal.behaviors.ELB_navaccordion = {
    attach: function (context, settings) {
      // apply our custom jQuery pugin
      $('.accordian-page__accordian').accordianMenu({ activeClass: 'sidebar-link--is-active' });
    }
  };
})(jQuery);
